import React from 'react'
import Project from '../Components/Project/Project'
import { useTranslation } from 'react-i18next'
import Button from '../Components/Button/Button'

const Projects = () => {
  const {t} = useTranslation()
  return (
    <div className='pt-4 bg-[#091c30]'>
      <div><h1 className='text-center xs:text-5xl xxs:text-4xl sm:text-6xl font-bold  font-serif text-white pb-12 pt-12 '>{t("LatestProject")}</h1>
    <Project img1={"./images/ziaja1.png"} img2={"./images/ziaja11.png"} img3={"./images/ziaja111.png"} />
   <section className='flex justify-center my-3'> <Button To={"https://en.ziaja.com/"} Data={t("Live")} /></section>
    <section className='mt-4'>
    <Project img1={"./images/wax1.png"} img2={"./images/wax11.png"} img3={"./images/wax111.png"} />
   <section className='flex justify-center my-3'> <Button To={"https://www.waxexplore.com/"} Data={t("Live")} /></section>
   
    </section>
    <section className='mt-4'>
    <Project img1={"./images/OMEGA1.png"} img2={"./images/omega11.png"} img3={"./images/omega111.png"} />
      <section className='flex justify-center my-3'> <Button To={"https://omegacryptotrade.com/"} Data={t("Live")} /></section>

    </section>
    <section className='mt-4'>
    <Project img1={"./images/omni1.png"} img2={"./images/omni11.png"} img3={"./images/omni111.png"} />
      <section className='flex justify-center py-3'> <Button To={"https://omnistock.io/"} Data={t("Live")} /></section>

    </section>
    </div>
    </div>
  )
}

export default Projects
